export const SOCIAL_MEDIA_DATA_GA = {
  event: 'social-media',
  group: {
    link: 'social-media-link',
    share: 'social-media-share',
  },
} as const;

export const SOCIAL_MEDIA_DATA_TEST = {
  link: 'social-media-link',
  share: 'social-media-share',
} as const;
